import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'Messages/'

export const messagesService = {
  getAll,
  getAllByUserId,
  getById,
  add,
  edit,
  delete: _delete,
  getImages,
  changeStatus
}

function getAll(dto) {
  const url = base_url + model + 'GetAll'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllByUserId(userId, dto) {
  const url = base_url + model + 'GetAllByUserID/' + userId
  // console.log(url, dto);

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function changeStatus(dto) {
  const url = base_url + model + 'changeStatus'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function edit(id, dto) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function getImages(id) {
  const url = base_url + model + 'getImages/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}
